module.exports = __webpack_public_path__ + "packs/media/images/image_party-4f89506541e5c297630755f9228b00ae.png";